import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function AboutPreview() {
  return (
    <section
      id="a-propos"
      data-testid="about-preview-section"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-[#F3EEF4] border border-[#DDD7E2] shadow-[0_20px_60px_-20px_rgba(40,71,184,0.15)]">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/6b768130-5bfa-4898-afec-a0670faefdd4/images/a0f8c51a2c06b4448180bfcfd9471df8f52053eceb63b32f946ee25a188dfdd7.png"
                alt=""
                className="w-full h-full object-cover opacity-95"
              />
              <div className="absolute bottom-6 left-6 right-6 px-5 py-4 rounded-2xl bg-white/85 backdrop-blur-md border border-[#DDD7E2]">
                <p className="text-xs uppercase tracking-[0.22em] text-[#C98FA3] font-medium">
                  Praticienne
                </p>
                <p className="font-serif-display text-2xl text-[#1E1E2A] mt-1">
                  Francine Banzadio
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — À propos
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Un parcours scientifique
              <br />
              au service de l'humain
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#5F6170] text-base md:text-lg leading-relaxed">
              <p>
                Après un parcours scientifique et analytique, je me suis orientée vers
                l'accompagnement des personnes.
              </p>
              <p>
                Formée à la sophro-analyse des mémoires prénatales, de la naissance et de
                l'enfance, ainsi qu'aux constellations familiales et systémiques, j'accompagne
                depuis plus de 15 ans des personnes confrontées à des blocages émotionnels
                et à des schémas répétitifs.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <Link
              to="/a-propos"
              data-testid="about-preview-cta"
              className="mt-10 inline-flex items-center gap-2 text-[#2847B8] font-medium hover:text-[#3A2E6E] transition-colors group"
            >
              En savoir plus
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
